import { createSlice } from '@reduxjs/toolkit';

// toClose: notistack keys (options.key) a saga asked to close, e.g. a "Sending..." snackbar once the request finished.
const initialState = { snackbars: [], snackbarId: 0, displayed: [], toClose: [] };

const snackbarsSlice = createSlice({
    name: 'snackbars',
    initialState,
    reducers: {
        enqueueSnackbar(state, { payload: notification }) {
            if (!state.snackbars.length && !state.displayed.length) state.snackbarId = 0;

            ++state.snackbarId;
            state.snackbars.push({ key: state.snackbarId, ...notification });
        },

        removeSnackbar(state, { payload: key }) {
            state.snackbars = state.snackbars.filter((snackbar) => snackbar.key !== key);

            state.displayed = state.displayed.filter((displayedKey) => displayedKey !== key);
        },

        updateDisplayedSnackbars(state, { payload: key }) {
            state.displayed.push(key);
        },

        closeSnackbar(state, { payload: key }) {
            if (!state.toClose.includes(key)) state.toClose.push(key);
        },

        snackbarClosed(state, { payload: key }) {
            state.toClose = state.toClose.filter((closeKey) => closeKey !== key);
        },
    },
});

export const snackbarsReducer = snackbarsSlice.reducer;
export const snackbarActions = snackbarsSlice.actions;
